<script>
import NavBar from '@components/NavBar/NavBar.vue'
import SessionExpiredModal from '@components/modals/SessionExpiredModal/SessionExpiredModal.vue'
import { mapState } from 'vuex'

export default {
  components: { NavBar, SessionExpiredModal },
  computed: {
    ...mapState('users', ['userSessionExpired']),
  },
}
</script>

<template>
  <div>
    <NavBar/>

    <main :class="$style.container">
      <slot/>
    </main>


    <SessionExpiredModal :user-session-expired="userSessionExpired"/>
  </div>
</template>

<style lang="scss" module>
@import '@shared/assets/sass/design/_breakpoints';

.container {
  @apply mb-8;

  @media screen and (min-width: $bp-mobile) {
    @apply pb-16 mb-0 mx-auto;
    min-width: 450px;
    max-width: 1280px;
  }

  @media screen and (min-width: 1420px) {
    @apply pb-16 mb-0 mx-auto;
    min-width: 450px;
    max-width: 1480px;
  }
}
</style>
